export default __webpack_public_path__ + "static/media/1-6-2.1e315faf.jpg";